
 <template lang="">
    
  <v-container class="fill-height justify-center page" fluid  >
        <v-card
          class="form-card"
          style="width: 50%"
          outlined 
        >
         <FormNewOwner v-bind:page="pageIndex" v-bind:jwt="jwt" ></FormNewOwner> 
     
            </v-card>
      </v-container>
 </template>
 <style  lang="scss"> 

 </style>
 <script>
     
import EasyPlanClient from '../utils/EasyPlanClient'
 import FormNewOwner from '../components/OwnerRegistration/FormNewOwner'
 export default {
    data:function(){
      return{
        pageIndex:0,
        jwt:"",
      }
    },
     components:{
         FormNewOwner
     },
     created(){
       if(this.$route.query!=undefined)
        {
            if(this.$route.query.action!=undefined)
              switch(this.$route.query.action)
              {
                case "account-verification":
                  this.pageIndex=3;
                  break;
                  case "company-creation":
                  this.pageIndex=4;
                  break; 
                  default:
                  this.pageIndex=0;
                  break;
              }
            if(this.$route.query.jwt!=undefined)
              this.jwt=this.$route.query.jwt;
        } 
        else{
            if(localStorage.userToken!=undefined && localStorage.userToken!="null")
            {
                  console.debug("redirecting");
                  EasyPlanClient.SetJWT(localStorage.userToken);
                  this.$router.push({
                    name: "owner-dashboard", 
                  }); 
            }
        }
     }
 }
 </script>